export const leads = [
  { id: 1, status: "Won", source: "Website" },
  { id: 2, status: "Open", source: "Instagram" },
  { id: 3, status: "Won", source: "Referral" },
];

export const customers = [
  { id: 1, name: "Rahul" },
  { id: 2, name: "Amit" },
];

export const bookings = [
  {
    id: 1,
    status: "Confirmed",
    destination: "Bali",
    total_amount: 85000,
    created_at: "2025-01-10",
  },
  {
    id: 2,
    status: "Completed",
    destination: "Dubai",
    total_amount: 120000,
    created_at: "2025-02-15",
  },
];

export const packages = [
  { id: 1, name: "Bali Honeymoon", active: true },
  { id: 2, name: "Dubai Luxury", active: true },
];
